import React from 'react';

/* @Components */
import { HeaderComponent } from './HeaderComponent';

export const HeaderContainer = () => {
  return <HeaderComponent />;
};
